export enum FanType {
    Backward = "Backward",
    Forward = "Forward",
    Axial = "Axial",
    Custom = "Custom"
}